import React from "react";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import {
  MyBarChartPaper,
  MyBarChartPaper2,
  MyPaper,
  MyPieChartPaper,
  MyStaffChartPaper,
} from "./MyPapers";
import { MyProgressBar } from "./MyProgressBars";
import { MyBarChart, MyPieChart, MyPieChart2 } from "./MyCharts";

export const MyTextCard = (inputs) => {
  const { value, title, size } = inputs.inputs;
  return (
    <Grid item xs={2} sm={4} md={size}>
      <MyPaper>
        <Box>
          <Typography
            color="primary.dark"
            sx={{ fontSize: "32px", fontWeight: "bold" }}>
            {value}
          </Typography>
          <Typography
            color="secondary.light"
            sx={{ fontSize: "20px", fontWeight: "400" }}>
            {title}
          </Typography>
        </Box>
      </MyPaper>
    </Grid>
  );
};

export const MyBarChartCard = (inputs) => {
  const { title, option1, value1, option2, value2 } = inputs.inputs;
  return (
    <Grid item xs={2} sm={4} md={3}>
      <MyBarChartPaper>
        <Typography
          color="primary.dark"
          sx={{ fontSize: "15px", fontWeight: "500" }}
          component="p">
          {title}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <Typography variant="p">{option1}</Typography>
          <Typography variant="p">{value1}</Typography>
        </Box>
        <MyProgressBar
          variant="determinate"
          value={(value1 / (value1 + value2)) * 100}
          color="primary"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}>
          <Typography variant="p">{option2}</Typography>
          <Typography variant="p">{value2}</Typography>
        </Box>
        <MyProgressBar
          variant="determinate"
          value={(value2 / (value1 + value2)) * 100}
          color="secondary"
        />
      </MyBarChartPaper>
    </Grid>
  );
};

export const MyBarChartCard2 = (inputs) => {
  const { title, option1, value1, option2, value2, option3, value3 } =
    inputs.inputs;
  return (
    <Grid item xs={2} sm={4} md={3}>
      <MyBarChartPaper2>
        <Typography
          color="primary.dark"
          sx={{ fontSize: "15px", fontWeight: "500" }}
          component="p">
          {title}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <Typography variant="p">{option1}</Typography>
          <Typography variant="p">{value1}</Typography>
        </Box>
        <MyProgressBar variant="determinate" value={value1} color="primary" />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}>
          <Typography variant="p">{option2}</Typography>
          <Typography variant="p">{value2}</Typography>
        </Box>
        <MyProgressBar variant="determinate" value={value2} color="secondary" />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}>
          <Typography variant="p">{option3}</Typography>
          <Typography variant="p">{value3}</Typography>
        </Box>
        <MyProgressBar variant="determinate" value={value3} color="secondary" />
      </MyBarChartPaper2>
    </Grid>
  );
};

export const MyPieChartCard = (inputs) => {
  const { mydata } = inputs.inputs;
  return (
    <Grid item xs={2} sm={4} md={3}>
      <MyPieChartPaper>
        <MyPieChart mydata={mydata} />
      </MyPieChartPaper>
    </Grid>
  );
};

export const MyPieChartCard2 = (inputs) => {
  const { mydata } = inputs.inputs;
  return (
    <Grid item xs={2} sm={4} md={3}>
      <MyPieChartPaper>
        <MyPieChart2 mydata={mydata} />
      </MyPieChartPaper>
    </Grid>
  );
};

export const MyStaffLoadCard = (inputs) => {
  const { mydata } = inputs.inputs;
  return (
    <Grid item xs={4} sm={8} md={12}>
      <MyStaffChartPaper>
        <MyBarChart mydata={mydata} />
      </MyStaffChartPaper>
    </Grid>
  );
};
